import { __extends } from "tslib";
import { Event } from './Event';
var AccelerometerEvent = /** @class */ (function (_super) {
    __extends(AccelerometerEvent, _super);
    function AccelerometerEvent(type, bubbles, cancelable, timestamp, accelerationX, accelerationY, accelerationZ) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (timestamp === void 0) { timestamp = 0; }
        if (accelerationX === void 0) { accelerationX = 0; }
        if (accelerationY === void 0) { accelerationY = 0; }
        if (accelerationZ === void 0) { accelerationZ = 0; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.timestamp = +timestamp;
        _this.accelerationX = +accelerationX;
        _this.accelerationY = +accelerationY;
        _this.accelerationZ = +accelerationZ;
        return _this;
    }
    AccelerometerEvent.classInitializer = null;
    AccelerometerEvent.classSymbols = null;
    AccelerometerEvent.instanceSymbols = null;
    // JS -> AS Bindings
    AccelerometerEvent.UPDATE = 'update';
    return AccelerometerEvent;
}(Event));
export { AccelerometerEvent };
